// import type { LOAN_REQUEST_OFFER_STATE } from 'cpool-constants';
// import type { EventSchema } from 'cpool-events';
import { z } from 'zod';

import { schemaOfferRequestsEuropace } from './discriminatedUnions';

// export type OfferRequestsTableSchema = {
//     conditions: typeof schemaConditions;
//     eventId: string | null;
//     id: string;
//     loanRequestId: string;
//     requestedAt: number;
//     state: LOAN_REQUEST_OFFER_STATE;
// } & {
//     failedReason: EventSchema<LoanRequest_EuropaceLoanOffersErrorsResponseReceived>['reason'] | null;
//     response: EventSchema<LoanRequest_EuropaceLoanOffersSuccessResponseReceived>['response'] | null;
//     source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE;
// };

export const OfferRequestsTableDefinitionZod = z.discriminatedUnion('source', [schemaOfferRequestsEuropace]);

export type OfferRequestsTableSchema = z.infer<typeof OfferRequestsTableDefinitionZod>;
export type OfferRequestsTableSchemaEuropace = z.infer<typeof schemaOfferRequestsEuropace>;
